
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface BaseSelectorProps {
  bases: { id: number; name: string }[];
  selectedBase: string;
  onBaseChange: (value: string) => void;
  onAssignBase: () => void;
  saving: boolean;
}

export const BaseSelector = ({
  bases,
  selectedBase,
  onBaseChange,
  onAssignBase,
  saving
}: BaseSelectorProps) => {
  return (
    <div className="flex gap-2 mb-4">
      <Select value={selectedBase} onValueChange={onBaseChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Select a base" />
        </SelectTrigger>
        <SelectContent>
          {bases.map((base) => (
            <SelectItem key={base.id} value={base.name}>
              {base.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button 
        onClick={onAssignBase} 
        disabled={!selectedBase || saving}
      >
        {saving ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Assigning...
          </>
        ) : (
          "Assign Base"
        )}
      </Button>
    </div>
  );
};
